import { render, staticRenderFns } from "./PontoCultural.vue?vue&type=template&id=c87f3d48&scoped=true&"
import script from "./PontoCultural.vue?vue&type=script&lang=js&"
export * from "./PontoCultural.vue?vue&type=script&lang=js&"
import style0 from "./PontoCultural.vue?vue&type=style&index=0&id=c87f3d48&lang=scss&scoped=true&"
import style1 from "./PontoCultural.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f3d48",
  null
  
)

export default component.exports